import axiosInstance from '@/utils/api.js'

function validation (payload) {

}

var state = {
  groups: [],
  groupInfo: []
}

var getters = {
  GROUPS: (state) => {
    return state.groups
  },
  GROUPS_INFO: (state) => {
    return state.groupInfo
  }
}

var mutations = {
  SET_GROUPS: (state, payload) => {
    state.groups = payload
  },
  SET_GROUPS_INFO: (state, payload) => {
    state.groupInfo = payload
  }
}

var actions = {
  GET_GROUPS: async (context, payload) => {
    let result = await axiosInstance.get('/users/groups')
    if (result.status === 200) {
      context.commit('SET_GROUPS', result.data)
    }
  },
  CREATE_GROUPS: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/users/groups', payload)
  },
  UPDATE_GROUPS: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/users/groups', payload)
  },
  DELETE_GROUPS: (context, payload) => {
    return axiosInstance.delete('/users/groups?group_id=' + payload)
  },
  GET_GROUP_INFO: async (context, payload) => {
    let result = await axiosInstance.get('/users/group_info?group_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_GROUPS_INFO', result.data)
    }
  },
  DELETE_USER_FROM_GROUPS: (context, payload) => {
    return axiosInstance.delete('/users/user_from_group?user_id=' + payload.user_id + '&group_id=' + payload.group_id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/groups.js